<template>
  <div class="industry">
    <div class="industry-left">
      <div class="industry-left-top">
        <div class="industry-box">
          <div class="industry-zsys">
            <div class="industry-zsys-title">产业导向</div>
            <div class="industry-zsys-body1">
              <div class="body1-industry">
                <div class="industry-item">
                  <img src="@/assets/images/plant/item-1.png" />
                  <div class="item-text">轻工纺织</div>
                </div>
                <div class="industry-item">
                  <img src="@/assets/images/plant/item-2.png" />
                  <div class="item-text">肉牛肉羊</div>
                </div>
                <div class="industry-item">
                  <img src="@/assets/images/plant/item-3.png" />
                  <div class="item-text">现代农业</div>
                </div>
                <div class="industry-item">
                  <img src="@/assets/images/plant/item-4.png" />
                  <div class="item-text">奶产业</div>
                </div>
                <div class="industry-item">
                  <img src="@/assets/images/plant/item-5.png" />
                  <div class="item-text">装备制造</div>
                </div>
                <div class="industry-item">
                  <img src="@/assets/images/plant/item-6.png" />
                  <div class="item-text">清洁能源</div>
                </div>
                <div class="industry-item">
                  <img src="@/assets/images/plant/item-7.png" />
                  <div class="item-text">绿色食品</div>
                </div>
                <div class="industry-item">
                  <img src="@/assets/images/plant/item-8.png" />
                  <div class="item-text">健康养老</div>
                </div>
                <div class="industry-item">
                  <img src="@/assets/images/plant/item-9.png" />
                  <div class="item-text">优质饲草</div>
                </div>
                <div class="industry-item">
                  <img src="@/assets/images/plant/item-10.png" />
                  <div class="item-text">文化旅游</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="industry-left-bottom">
        <div class="industry-box">
          <div class="industry-zsys">
            <div class="industry-zsys-title">招商政策</div>
            <div class="industry-zsys-body2">
              <div class="body2-left">
                <div class="left-title">投资成本</div>
                <div class="text-content-img">
                  <img src="@/assets/images/text-img.png" />
                  <p>
                    投资规模稳定扩大。全区固定资产投资增长6%左右,完成投资2200亿元以上。其中,银川市(不含宁东能源化工基地)增长6%,完成投资690亿元以上;石嘴山市增长7%,完成投资230亿元以上;吴忠市增长6%,完成投资510亿元以上;固原市增长6%,完成投资210亿元以上;中卫市增长8%,完成投资300亿元以上;宁东能源化工基地增长8%,完成投资300亿元以上。
                  </p>
                </div>
                <p class="more-btn" @click="handleShowMore">点击查看投资成本</p>
                <!-- <div class="industryZsys-item industryZsys-item-blue">
                  <div>
                    <countTo
                      :startVal="0"
                      :endVal="statistics.landUse"
                      :duration="3000"
                    ></countTo>
                  </div>
                  <div>招商规划用地</div>
                </div>
                <div class="industryZsys-item industryZsys-item-orange">
                  <div>
                    <countTo
                      :startVal="0"
                      :endVal="statistics.talentSubsidy"
                      :duration="3000"
                    ></countTo>
                  </div>
                  <div>人才补贴(万元)</div>
                </div>
                <div class="industryZsys-item industryZsys-item-red">
                  <div>
                    <countTo
                      :startVal="0"
                      :endVal="statistics.talentSupport"
                      :decimals="2"
                      :duration="3000"
                    ></countTo>
                  </div>
                  <div>人才扶持资金(万元)</div>
                </div> -->
              </div>
              <div class="body2-right">
                <div class="right-title">招商政策</div>
                <div class="tbas-list">
                  <div
                    class="list-item"
                    v-for="(item, index) in tabsList"
                    :key="index"
                    @click="handleTabs(index)"
                  >
                    {{ item }}
                  </div>
                </div>
                <div class="tabs-content" v-if="currentIndex == 0">
                  <p>
                    1、投资规模稳定扩大。全区固定资产投资增长6%左右,完成投资2200亿元以上。其中,银川市(不含宁东能源化工基地)增长6%,完成投资690亿元以上;石嘴山市增长7%,完成投资230亿元以上;吴忠市增长6%,完成投资510亿元以上;固原市增长6%,完成投资210亿元以上;中卫市增长8%,完成投资300亿元以上;宁东能源化工基地增长8%,完成投资300亿元以上。
                  </p>
                  <p class="p-title">
                    2、投资结构持续优化。工业投资增长15%以上，其中,采矿业投资增长12%以上,制造业投资增长10%以上、占工业投资比重提高至45%以上,以新能源为主的电力业投资增长50%以上、占工业投资比重提高至50%以上;基础设施投资增长2%以上,其中,水利基础设施投资增长15%以上、占基础设施投资比重提高至50%以上,信息基础设施投资增长10%以上、占基础设施投资比重提高至12%以上。
                  </p>
                </div>
                <div class="tabs-content" v-if="currentIndex == 1">
                  <p>
                    1、实际到位资金2亿元以上（含2亿元）、10亿元以下的工业项目（含农副产品深加工项目），在项目按期竣工并投产后，按照实际到位资金的1‰给予资金支持；实际到位资金10亿元以上（含10亿元）的，按照实际到位资金的2‰给予资金支持，最高不超过500万元。
                  </p>
                  <p class="p-title">
                    2、实际到位资金2亿元以上（含2亿元）的文化旅游、物流仓储等现代服务业项目，在项目按期竣工并运营后，按照实际到位资金的1‰给予资金支持，最高不超过500万元。
                  </p>
                  <p class="p-title">
                    3、对在我市新设立的银行、信托、金融租赁、融资租赁、基金管理、融资性担保以及股权产权投资类等现代金融服务企业，一次性给予其注册资本或营运资本（按实际到位资金计算）1%的资金支持，最高不超过500万元。
                  </p>
                </div>
                <div class="tabs-content" v-if="currentIndex == 2">
                  <p>
                    1、全区经济运行保持总体平稳、稳进向好的态势，预计全年地区生产总值增长5.5%，其中：第一产业同比增长6.5%，第二产业同比增长3.5%，第三产业同比增长6.5%。规模以上工业增加值同比增长3.5%，固定资产投资同比增长5%，社会消费品零售总额同比增长1.5%，一般公共预算收入同比增长6.8%，城乡居民人均可支配收入分别同比增长6.5%、8%，城镇调查失业率控制在5.5%以内，居民消费价格涨幅控制在3%以内
                  </p>
                  <p class="p-title" style="-webkit-line-clamp: 5">
                    2、全面落实自治区优化营商环境推动民营经济高质量发展“31条”、市场主体梯度培育提质升级行动计划“24条”等一揽子政策措施，经济结构调整优化，新动能持续显现，主要经济指标全面增长、量质齐升，预计三次产业结构比为11.5:41.5:47，经济运行稳固向好。市场主体发展向好。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="industry-center">
      <div class="center-zsys-title" style="top: 0.1rem">多彩利通</div>
      <div class="center-zsr">
        <!-- 2022年总收入
        <span v-for="(item, index) in zslje" :key="index">{{ item }}</span>
        元-->
        吴忠市利通区地处银川平原南端，西临黄河与青铜峡市毗连,南与中宁、同心两县交界;东北部与灵武市接壤;距宁夏首府银川市59公里。面积1313平方千米。全区辖8镇4乡，国土面积1112平方公里，总人口40.2万人，其中农业人口占69%，回族人口5一，同时也是地级吴2%，是宁夏回族聚居的主要地区之忠市市委、政府领导机关所在地。利通区地形地貌奇特，兼具江南水乡秀色和塞北大漠之雄浑,辖区地势南高北低，似宝瓶形，平均海拔1125米，属温带半干早气候区，具有春暖迟、夏热短、秋凉早、冬寒长的特点，年平均降水量193.4毫米，年平蒸发量2013.7毫米，年平均气温8.8°C，相对湿度53%，年均日照达2936小时，年平均无霜期171天。
      </div>

      <div class="map-tabs">
        <div
          class="tabs-item"
          v-for="(item, index) in tabsMaps"
          :key="index"
          @click="handleTabs2(index)"
        >
          {{ item }}
        </div>
      </div>

      <img v-if="mapIndex == 0" class="map-img" src="@/assets/images/map.gif" />
      <div id="map_1" v-else style="width: 100%; height: 100%"></div>
    </div>
    <div class="industry-right">
      <div
        class="industry-left-top"
        style="height: calc(100% - 0.04rem); margin: 0.04rem 0"
      >
        <div class="industry-box">
          <div class="industry-zsys">
            <div class="industry-zsys-title">园区</div>
            <div class="industry-zsys-body3">
              <!-- <div id="chart1" style="width: 100%; height: 100%"></div> -->
              <div class="body3-wrap">
                <div
                  class="wrap-item"
                  v-for="(item, index) in parkList"
                  :key="index"
                >
                  <img :src="item.img" />
                  <div class="text">{{ item.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="industry-left-bottom">
        <div class="industry-box">
          <div class="industry-zsys">
            <div class="industry-zsys-title">招商企业</div>
            <div class="industry-zsys-body3">
              <dv-scroll-board
                @click="skipto"
                :config="config"
                style="width: 100%; height: 100%; cursor: pointer"
              />
            </div>
          </div>
        </div>
      </div>-->
    </div>
    <!-- 招商企业详情 -->
    <div v-if="companyBox">
      <companyDetail :form="form" @handleClose="handleClose"></companyDetail>
    </div>
    <img
      ref="mapSvgAreaMap"
      id="mapSvg"
      v-show="false"
      hidden
      style="width: 500px; height: 500px"
      src="../assets/images/map_1.png"
    />
    <el-dialog :visible.sync="dialogTableVisible">
      <div class="dialog-img">
        <img v-for="item in bannerList" :key="item" :src="item" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ltqMap from "@/assets/json/ltq.json";

// import countTo from "vue-count-to";
import companyDetail from "@/components/companyDetail.vue";
import * as echarts from "echarts";
import "echarts-gl";
import api from "@/api/api";
export default {
  name: "industryChain",
  components: {
    // countTo,
    companyDetail,
  },
  data() {
    return {
      myChart: null,
      myChart2: null,
      myChart3: null,
      config: {},
      statistics: {
        areaCount: 0,
        articleConut: 0,
        doctorCount: 0,
        facilitiesCount: 0,
        foodCount: 0,
        healthCount: 0,
        industryCount: 0,
        nongjialeCount: 0,
        nursingCount: 0,
        productCount: 0,
        viewCount: 0,
        landUse: 0,
      },
      flylineConfig: {
        points: [
          {
            name: "上桥镇",
            coordinate: [0.36, 0.27],
            halo: {
              show: true,
            },
            icon: {
              src: require("../assets/images/mapCenterPoint.png"),
              width: 30,
              height: 30,
            },
            text: {
              show: false,
            },
          },
          {
            name: "上桥镇",
            coordinate: [0.36, 0.27],
          },
          {
            name: "金银滩镇",
            coordinate: [0.45, 0.35],
          },
          {
            name: "高闸镇",
            coordinate: [0.34, 0.4],
          },
          {
            name: "扁担沟镇",
            coordinate: [0.38, 0.5],
          },
          {
            name: "马莲渠乡",
            coordinate: [0.33, 0.35],
          },
        ],
        lines: [
          {
            source: "金银滩镇",
            target: "上桥镇",
          },
          {
            source: "高闸镇",
            target: "上桥镇",
          },
          {
            source: "扁担沟镇",
            target: "上桥镇",
          },
          {
            source: "马莲渠乡",
            target: "上桥镇",
          },
        ],
        icon: {
          show: true,
          src: require("../assets/images/mapPoint.png"),
        },
        bgImgSrc: require("../assets/images/map.jpg"),
        text: {
          show: true,
        },
        line: {
          width: 2,
        },
      },
      companyBox: false,
      form: {},
      tableList: [],
      zslje: "745624",
      xzxxList: [],
      tabsList: ["自治区政策", "吴忠市政策", "利通区政策"],
      currentIndex: 0,
      tabsMaps: ["交通", "园区", "土地", "产业"],
      mapIndex: 0,
      datamap: [
        {
          name: "古城镇",
          area: 2500,
          plant: 1,
          park: 1,
          parkName: "",
        },
        {
          name: "金星镇",
          area: 2150,
          plant: 3,
          park: 2,
          parkName: "吴忠国家农业科技园区",
        },
        {
          name: "高闸镇",
          area: 1509,
          plant: 2,
          park: 4,
          parkName: "吴忠国家级农业科技示范园高产奶牛基地",
        },
        {
          name: "上桥镇",
          area: 1234,
          plant: 4,
          park: 15,
          parkName: "",
        },
        {
          name: "马莲渠乡",
          area: 3678,
          plant: 5,
          park: 1,
          parkName: "吴忠市利通区健康产业园",
        },
        {
          name: "郭家桥乡",
          area: 89,
          plant: 1,
          park: 2,
          parkName: "吴忠市上桥镇失地农民创业园",
        },
        {
          name: "胜利镇",
          area: 976,
          plant: 21,
          park: 3,
          parkName: "吴忠市五里坡奶牛养殖园区",
        },
        {
          name: "东塔寺乡",
          area: 446,
          plant: 1,
          park: 3,
          parkName: "吴忠市利通区健康产业园",
        },
        {
          name: "金银滩镇",
          area: 3424,
          plant: 66,
          park: 4,
          parkName: "金银滩特色装备制造产业园",
        },
        {
          name: "孙家滩管委会",
          area: 5422,
          plant: 6,
          park: 5,
          parkName: "吴忠市孙家滩农业综合开发区",
        },
        {
          name: "巴浪湖农场",
          area: 6778,
          plant: 7,
          park: 5,
          parkName: "吴忠市利通区工业产业园",
        },
        {
          name: "金积镇",
          area: 1321,
          plant: 5,
          park: 1,
          parkName: "吴忠金积工业园区",
        },
        {
          name: "板桥乡",
          area: 1453,
          plant: 6,
          park: 5,
          parkName: "吴忠市利通区牛奶产业园",
        },
        {
          name: "扁担沟镇",
          area: 2342,
          plant: 10,
          park: 7,
          parkName: "吴忠市五里坡奶牛养殖园区",
        },
      ],
      parkList: [
        {
          name: "金银滩特色装备制造产业园",
          img: require("@/assets/images/park/item-1.png"),
        },
        {
          name: "吴忠市孙家滩农业综合开发区",
          img: require("@/assets/images/park/item-2.png"),
        },
        {
          name: "吴忠市利通区健康产业园",
          img: require("@/assets/images/park/item-3.png"),
        },
        {
          name: "吴忠市五里坡奶牛养殖园区",
          img: require("@/assets/images/park/item-4.png"),
        },
        {
          name: "吴忠市上桥镇失地农民创业园",
          img: require("@/assets/images/park/item-5.png"),
        },
        {
          name: "吴忠金积工业园区",
          img: require("@/assets/images/park/item-6.png"),
        },
      ],
      parkAddress: [
        {
          name: "金银滩特色装备制造产业园",
          value: [106.278542, 37.918882],
        },
        {
          name: "吴忠市孙家滩农业综合开发区",
          value: [106.25153, 37.737597],
        },
        {
          name: "吴忠市利通区健康产业园",
          value: [106.244267, 38.008962],
        },
        {
          name: "吴忠市五里坡奶牛养殖园区",
          value: [106.329191, 37.731684],
        },
        {
          name: "吴忠市上桥镇失地农民创业园",
          value: [106.242903, 37.976865],
        },
        {
          name: "吴忠金积工业园区",
          value: [106.140555, 37.952279],
        },
      ],
      dialogTableVisible: false,
      bannerList: [
        require("@/assets/images/banner-1.png"),
        require("@/assets/images/banner-2.png"),
      ],
    };
  },
  mounted() {
    // this.initChart();
    if (this.mapIndex != 0) {
      this.createMap();
    }

    // this.getMerchantList();
    // this.getInvestList();
  },
  methods: {
    // 投资成本显示
    handleShowMore() {
      this.dialogTableVisible = true;
    },
    // 地图选项卡切换
    handleTabs2(index) {
      this.mapIndex = index;
      if (index != 0) {
        if (this.myChart) {
          this.myChart.dispose(); // 清理旧的echarts实例
        }
        this.$nextTick(() => {
          this.createMap();
        });
      }
    },
    // 选项卡切换
    handleTabs(index) {
      this.currentIndex = index;
    },
    // 关闭弹窗
    handleClose() {
      this.companyBox = false;
    },
    // 招商政策
    skipto(config) {
      this.form = this.tableList[config.rowIndex];
      this.companyBox = true;
    },
    getInvestList() {
      api
        .getInvestList({
          pageNum: 1,
          pageSize: 100,
        })
        .then((res) => {
          this.xzxxList = res.rows;

          let statistics = {
            attractPaid: 0,
            basePaid: 0,
            cityPaid: 0,
            medicalPaid: 0,
            elsePaid: 0,
            landUse: 0,
            talentSubsidy: 0,
            talentSupport: 0,
            income: 0,
          };
          res.rows.forEach((item) => {
            statistics.attractPaid += Number(item.attractPaid);
            statistics.basePaid += Number(item.basePaid);
            statistics.cityPaid += Number(item.cityPaid);
            statistics.medicalPaid += Number(item.medicalPaid);
            statistics.elsePaid += Number(item.elsePaid);
            statistics.landUse += Number(item.landUse);
            statistics.talentSubsidy += Number(item.talentSubsidy);
            statistics.talentSupport += Number(item.talentSupport);
            statistics.income += Number(item.income);
          });
          this.statistics = statistics;
          this.zslje = String(statistics.income * 10000);
          // this.initBarChart(statistics);
        });
    },
    getMerchantList() {
      api.getMerchantList().then((res) => {
        this.config = {
          align: ["left", "right"],
          oddRowBGC: "transparent",
          evenRowBGC: "transparent",
          rowNum: 6,
          data: res.rows.map((item) => {
            return [item.firmName, item.firmArea];
          }),
        };
        this.tableList = res.rows;
      });
    },
    initBarChart(statistics) {
      let winWidth = window.innerWidth;
      const that = this;
      that.myChart3 = echarts.init(document.getElementById("zcqk"));
      const option = {
        // backgroundColor: '#2c343c',
        // color:['#488CF7','#00ff00','#0000ff','#ffff00','#ff00ff','#00ffff'],
        title: {
          text: "2022年总支出情况",
          left: "center",
          top: winWidth >= 5000 ? 20 : 0,
          textStyle: {
            color: "#ccc",
          },
        },
        tooltip: {
          trigger: "item",
        },
        visualMap: {
          show: false,
          min: 100,
          max: 2000,
          inRange: {
            colorLightness: [0, 1],
          },
        },
        series: [
          {
            name: "支出情况",
            type: "pie",
            radius: "55%",
            center: ["50%", "50%"],
            data: [
              { value: Number(statistics.attractPaid), name: "招商规划" },
              { value: Number(statistics.basePaid), name: "基础建设" },
              { value: Number(statistics.talentSupport), name: "人才扶持" },
              { value: Number(statistics.cityPaid), name: "城乡规划" },
              { value: Number(statistics.medicalPaid), name: "医疗补贴" },
              { value: Number(statistics.talentSubsidy), name: "人才补贴" },
              { value: Number(statistics.elsePaid), name: "其他" },
            ].sort(function (a, b) {
              return a.value - b.value;
            }),
            roseType: "radius",
            label: {
              color: "rgba(255, 255, 255, 1)",
              fontSize: winWidth >= 5000 ? 20 : 14,
              alignTo: "edge",
              formatter: "{name|{b}}\n{time|{c} 万元}",
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 24,
              rich: {
                time: {
                  fontSize: winWidth >= 5000 ? 20 : 14,
                  color: "#999",
                },
              },
            },
            labelLine: {
              lineStyle: {
                color: "rgba(255, 255, 255, 1)",
              },
              smooth: 0.2,
              length: 10,
              length2: 20,
            },
            itemStyle: {
              color: "#69a3ff",
              shadowBlur: 200,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
            animationType: "scale",
            animationEasing: "elasticOut",
            animationDelay: function () {
              return Math.random() * 200;
            },
          },
        ],
      };

      option && this.myChart3.setOption(option);
    },
    initChart() {
      let winWidth = window.innerWidth;
      const that = this;
      that.myChart2 = echarts.init(document.getElementById("chart1"));
      let dataRegion = []; //x-地区
      let dataProfit = []; //y-数值
      api.getLtMerchantCount().then((res) => {
        let grossDomesticProduct = res.data;
        grossDomesticProduct.forEach((v) => {
          dataRegion.push(v.name);
          dataProfit.push(v.total);
        });
        let option = {
          tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" },
          },
          xAxis: {
            type: "category",
            data: dataRegion,
            axisLine: {
              lineStyle: {
                color: "#FFF",
              },
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                fontSize: winWidth >= 5000 ? 20 : 14,
              },
            },
          },
          yAxis: {
            name: "企业数量(个)",
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#FFF",
              },
            },
            axisLabel: {
              textStyle: {
                fontSize: winWidth >= 5000 ? 20 : 14,
              },
            },
          },
          series: [
            {
              data: dataProfit,
              barWidth: 16,
              type: "bar",
              itemStyle: {
                normal: {
                  barBorderRadius: [24, 24, 0, 0],
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#48AC75" },
                    { offset: 1, color: "#1D9FCD" },
                  ]),
                },
              },
            },
          ],
        };
        setTimeout(() => {
          that.myChart2.setOption(option);
        }, 1000);
      });
      window.addEventListener("resize", () => {
        let winWidth = window.innerWidth;
        that.myChart2.setOption({
          xAxis: {
            axisLabel: {
              textStyle: {
                fontSize: winWidth >= 5000 ? 40 : 14,
              },
            },
          },
          yAxis: {
            axisLabel: {
              textStyle: {
                fontSize: winWidth >= 5000 ? 40 : 14,
              },
            },
          },
          series: [
            {
              barWidth: winWidth >= 5000 ? 40 : 20,
            },
          ],
        });
        that.myChart2.resize();
      });
    },
    // 涟漪
    lineData() {
      return this.datamap.map((item, index) => {
        return {
          name: "",
          value: [
            ltqMap.features[index].properties.center[0],
            ltqMap.features[index].properties.center[1],
          ],
        };
      });
    },
    // 坐标点
    scatterData() {
      return this.datamap.map((item, index) => {
        return [
          ltqMap.features[index].properties.center[0] + 0.008,
          ltqMap.features[index].properties.center[1] - 0.004,
          item,
        ];
      });
    },
    // 坐标点
    scatterData2() {
      return this.parkAddress.map((item) => {
        return [item.value[0] + 0.008, item.value[1] - 0.004, item];
      });
    },
    createMap() {
      let winWidth = window.innerWidth;
      echarts.registerMap("ltq", { geoJSON: ltqMap });
      this.myChart = echarts.init(document.getElementById("map_1"));
      let vm = this;
      const option = {
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            console.log("111", params);
            if (params.seriesType == "map" && vm.mapIndex == 2) {
              let data = vm.datamap.find((item) => item.name == params.name);
              var tipHtml = "";
              tipHtml = `
                    <div class="ui-map-img">
                        <div class='ui-maptxt'>${data.name}</div>
                        <div class='ui-mapNum'>空闲土地:${data.area}亩</div>
                        <div class='ui-mapNum'>空闲厂房:${data.plant}个</div>
                        <div class='ui-mapNum'>园区:${data.park}个</div>
                    </div>
                `;
              return tipHtml;
            } else if (params.seriesType == "scatter" && vm.mapIndex == 1) {
              var parkHtml = "";
              parkHtml = `
              <div>${params.data[2].parkName}</div>
            
`;
            }
            return parkHtml;
          },
          show: vm.mapIndex == 2 || vm.mapIndex == 1 ? true : false,
        },

        geo: [
          {
            map: "ltq",
            geoIndex: 2,
            label: {
              show: this.mapIndex == 2 ? true : false, //是否显示地图上标签
              textStyle: {
                color: "#fff",
              },
            },
            zlevel: 2,
            roam: false, //禁止其放大缩小
            itemStyle: {
              normal: {
                areaColor: "rgba(0,0,0,0.0)",
                borderColor: this.mapIndex == 2 ? "rgb(0,227,255)" : "none",
                borderWidth: 2,
                shadowColor: "rgb(0,227,255)",
                shadowBlur: 20,
                shadowOffsetX: -5,
                shadowOffsetY: 6,
                borderCap: "round",
                borderJoin: "round",
              },
              emphasis: {
                areaColor: "rgba(6,32,141,0.2)",
              },
            },
            groundPlane: {
              show: false,
            },
            left: winWidth >= 5000 ? "50%" : "20%",
            top: "15%",
          },
          {
            map: "ltq",
            geoIndex: 1,
            // layoutCenter: [winWidth >= 5000 ? '50%' : '20%', "15%"],
            layoutCenter: winWidth >= 5000 ? ["63%", "55%"] : ["52%", "55%"],
            layoutSize: winWidth >= 5000 ? "80%" : "90%",
            zlevel: 1,
            // aspectScale: 1,
            silent: true,
            label: {
              emphasis: {
                show: false,
              },
            },
            roam: false, // 是否允许缩放
            itemStyle:
              this.mapIndex == 2
                ? {
                    areaColor: {
                      image: this.$refs.mapSvgAreaMap, // 支持为 HTMLImageElement, HTMLCanvasElement，不支持路径字符串
                      repeat: "repeat", // 是否平铺, 可以是 'repeat-x', 'repeat-y', 'no-repeat'
                    },
                  }
                : {
                    normal: {
                      borderColor: "rgb(76,96,255)",
                      borderWidth: 0.8,
                      areaColor: {
                        type: "linear-gradient",
                        x: 0,
                        y: 300,
                        x2: 0,
                        y2: 0,
                        colorStops: [
                          {
                            offset: 0,
                            color: "rgb(76,96,255)", // 0% 处的颜色
                          },
                          {
                            offset: 1,
                            color: "rgb(76,96,255)",
                          },
                        ],
                        global: false, // 缺省为 false
                      },
                    },
                  },
            groundPlane: {
              show: true,
            },
          },
        ],
        series: [
          {
            type: "map",
            map: "ltq",
            geoIndex: 0,
            barWidth: 100,
            data: this.datamap,
            symbolSize: function (val) {
              return val[2] / 15;
            },
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: false,
              },
            },
            itemStyle: {
              color: "rgb(20, 15, 2)",
              borderWidth: 10,
              borderColor: "#FFF",
            },
          },
          {
            name: "factorys",
            type: "effectScatter",
            symbol: "circle",
            symbolSize: this.mapIndex == 0 ? 100 : 10,
            // 显示层级
            zlevel: 7,
            z: 3,
            coordinateSystem: "geo",
            geoIndex: 1,
            itemStyle: {
              show: true,
              color: this.mapIndex == 3 ? "#c0f3fb" : "rgba(81,179,248,1)",
            },
            rippleEffect: {
              period: 10,
              scale: 4,
              brushType: "fill",
            },
            emphasis: {
              disabled: true,
            },
            silent: true,
            data:
              this.mapIndex == 1
                ? this.lineData()
                : this.mapIndex == 3
                ? this.parkAddress
                : [],
          },
          {
            type: "scatter",

            coordinateSystem: "geo",
            zlevel: 99,
            rippleEffect: {
              period: 2,
              brushType: "stroke",
              scale: 1,
            },
            itemStyle: {
              //坐标点颜色
              color: this.mapIndex == 3 ? "#8cd3ef" : "rgba(255,255,100,1)",
            },

            label: {
              normal: {
                show: false,
                position: "right",
                color: "#0f0",
                formatter: "{b}",
                textStyle: {
                  color: "#0f0",
                },
              },
            },
            symbol: "pin", //定位图标样式
            symbolSize: 30,
            data:
              this.mapIndex == 1
                ? this.scatterData()
                : this.mapIndex == 3
                ? this.scatterData2()
                : [],
          },
        ],
      };

      this.myChart.setOption(option);
      const that = this;
      window.addEventListener("resize", () => {
        that.myChart.resize();
      });
    },
  },
};
</script>

<style scoped lang="scss">
.el-carousel__item img {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 900px;
  margin: 0;
}
.industry {
  height: 100%;
  display: flex;
  justify-content: space-between;

  .industry-left-top {
    height: calc(50% - 0.15rem);
    margin: 0.1rem 0;
  }

  .industry-left-bottom {
    height: calc(50% - 0.05rem);
  }

  .industry-box {
    background: url("../assets/images/bg-item.png") no-repeat;
    background-size: 100% 100%;
    height: 100%;
    position: relative;
  }
  .industry-box::after {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 20px;
    height: 20px;
    border-right: 2px solid #44aaff;
    border-bottom: 2px solid #44aaff;
    content: "";
  }

  .industry-box::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    border-left: 2px solid #44aaff;
    border-top: 2px solid #44aaff;

    content: "";
  }
  .industry-zsys::before {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 20px;
    height: 20px;
    border-left: 2px solid #44aaff;
    border-bottom: 2px solid #44aaff;
    content: "";
  }

  .industry-zsys::after {
    position: absolute;
    content: "";
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    border-right: 2px solid #44aaff;
    border-top: 2px solid #44aaff;
  }
  .industry-left {
    width: 30%;
    padding: 0 0.1rem 0.1rem 0.1rem;
  }

  .industry-zsys {
    padding: 0.1rem;
    height: calc(100%);

    .industry-zsys-title {
      margin-bottom: 0.2rem;
      text-align: center;
      font-size: 0.1rem;
      font-weight: bold;
      color: #a7dbff;
      background: url("../assets/images/title-bg.png") no-repeat;
      background-size: 100% 100%;
      padding: 0.1rem 0;
    }

    .industry-zsys-body3 {
      height: calc(100% - 0.5rem);

      // overflow-y: scroll;
      ::v-deep .dv-scroll-board .rows .ceil {
        font-size: 0.1rem;
      }

      .body3-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;

        .wrap-item {
          width: 45%;
          margin: 0.05rem;
          background: url("../assets/images/park-bg.png") no-repeat;
          background-size: 100% 100%;
          padding: 0.08rem;
          position: relative;

          img {
            width: 100%;
            height: 100%;
          }

          .text {
            position: absolute;
            bottom: 0.15rem;
            left: 50%;
            font-size: 0.12rem;
            white-space: nowrap;
            color: #fff;
            transform: translate(-50%, 0);
          }
        }
      }
    }

    .industry-zsys-body1 {
      height: calc(100% - 0.48rem);
      // text-indent: 0.32rem;
      font-size: 0.1rem;
      color: #fff;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 7;
      word-break: break-all;
      -webkit-box-orient: vertical;
      line-height: 0.2rem;

      .body1-industry {
        // display: flex;
        // align-items: center;
        // flex-wrap: wrap;
        // justify-content: flex-start;
        column-count: 5;
        column-gap: 0.1rem;
        .industry-item {
          position: relative;
          // width: 12%;
          // height: 12%;
          border-radius: 50%;
          // padding: 0.1rem;
          font-size: 0.12rem;
          // margin-right: 0.1rem;
          padding: 0.3rem 0;
          img {
            height: 100%;
            width: 100%;
          }

          .item-text {
            font-size: 0.06rem;
            white-space: nowrap;
            text-align: center;
            position: absolute;
            bottom: 10%;
            left: 50%;
            transform: translate(-50%, -10%);
          }
        }

        .industry-item::nth-child(5n) {
          margin-right: 0;
        }
      }
    }

    .industry-zsys-body2 {
      height: calc(100% - 0.5rem);
      font-size: 0.12rem;
      color: #fff;
      display: flex;
      justify-content: space-between;

      .body2-left {
        flex: 1;
        background: url("@/assets/images/zsys_bg.png") no-repeat;
        background-size: 100% 100%;
        height: 95%;
        display: flex;
        justify-content: space-between;
        position: relative;
        margin-right: 0.2rem;
        .left-title {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%, 0);
          color: #a7dbff;
        }

        .industryZsys-item {
          width: 27%;
          margin: 0 0.05rem;
          text-align: center;
          display: flex;
          flex-flow: column;
          justify-content: center;

          div:nth-of-type(1) {
            margin: 0.5rem 0 0.5rem;
            font-size: 0.22rem;
            font-weight: bold;
          }
        }
        .text-content-img {
          width: 95%;
          position: absolute;
          top: 0.5rem;
          left: 50%;
          transform: translate(-50%, 0);
          line-height: 1.8;
          img {
            float: right;
            width: 60%;
          }
        }
        .more-btn {
          position: absolute;
          top: 0.95rem;
          right: 0.3rem;
          color: #80e6ff;
          cursor: pointer;
        }
      }

      .body2-right {
        flex: 1;
        background: url("@/assets/images/zsys_bg.png") no-repeat;
        background-size: 100% 100%;
        height: 95%;
        position: relative;

        .right-title {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%, 0);
          color: #a7dbff;
        }

        .tbas-list {
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin: 0.5rem 0.1rem 0.1rem 0.1rem;

          .list-item {
            margin: 0.05rem 0.01rem;
            background: url("../assets/images/tabs-bg.png") no-repeat;
            background-size: 100% 100%;
            padding: 0.1rem;
            text-align: center;
            cursor: pointer;
          }
        }
      }

      .tabs-content {
        padding: 0 0.1rem;
        line-height: 1.5;
        .p-title {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 7;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .industryZsys-item-blue {
        color: #80e6ff;
        background: url("../assets/images/zszy_blue.png") no-repeat;
        background-size: 100%;
        background-position-y: 50%;
      }

      .industryZsys-item-orange {
        color: #ffba69;
        background: url("../assets/images/zszy_orange.png") no-repeat;
        background-size: 100%;
        background-position-y: 50%;
      }

      .industryZsys-item-red {
        color: #f27575;
        background: url("../assets/images/zszy_red.png") no-repeat;
        background-size: 100%;
        background-position-y: 50%;
      }
    }
  }

  .industry-center {
    width: 40%;
    padding: 0.1rem;
    margin: 0.1rem 0;
    position: relative;
    background: url("../assets/images/cyzsl_bg.png") no-repeat;
    background-size: 100% 100%;

    .center-zsys-title {
      position: absolute;
      width: 100%;
      text-align: center;
      font-size: 0.1rem;
      font-weight: bold;
      color: #a7dbff;
      top: 0;
    }
    .map-img {
      width: 95%;
      height: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .center-zsr {
      // position: absolute;
      // top: 0.25rem;
      // width: 100%;
      // text-align: center;
      // font-size: 0.1rem;
      // color: #fff;
      position: absolute;
      top: 0.4rem;
      /* width: 100%; */
      margin: 0 0.2rem;
      /* text-align: center; */
      font-size: 0.1rem;
      color: #fff;
      line-height: 1.7;
      // span {
      //   display: inline-block;
      //   font-size: 0.2rem;
      //   background: url("../assets/images/zsl_bg.png") no-repeat;
      //   height: 0.3rem;
      //   line-height: 0.3rem;
      //   width: 0.2rem;
      //   text-align: center;
      //   margin: 0 0.02rem;
      // }
    }

    .map-tabs {
      position: absolute;
      top: 1.3rem;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      font-size: 0.15rem;
      color: #fff;
      z-index: 999;

      .tabs-item {
        cursor: pointer;
        background: url("../assets/images/tabs-bg.png") no-repeat;
        background-size: 100% 100%;
        padding: 0.1rem 0.5rem;
      }
    }

    .center-xzxx {
      position: absolute;
      z-index: 1001;
      top: 0.7rem;
      width: 40%;
      left: 0.2rem;
      display: flex;
      flex-wrap: wrap;

      .center-xzxx-item {
        background: url("../assets/images/xzxx_bg.png") no-repeat;
        box-sizing: border-box;
        background-size: 100% 100%;
        padding: 0.1rem;
        width: 33%;
        color: #00ffff;
        text-align: center;
        height: 0.76rem;

        div:nth-of-type(1) {
          font-size: 0.1rem;
          margin: 0.06rem 0;
        }

        div:nth-of-type(2) {
          font-size: 0.1rem;

          span {
            font-size: 0.16rem;
          }
        }
      }
    }

    .center-zcqk {
      position: absolute;
      z-index: 1001;
      width: 35%;
      height: 2rem;
      right: 0.2rem;
      top: 0.7rem;
    }
  }

  .industry-right {
    width: 30%;
    padding: 0 0.1rem 0.1rem 0.1rem;
  }
}

@media screen and (max-width: 1920px) {
  .industry {
    .industry-zsys {
      .industry-zsys-body1 {
        font-size: 0.175rem;
        line-height: 0.3rem;
        padding: 0.1rem;
      }

      .industry-zsys-body2 {
        .industryZsys-item {
          div:nth-of-type(1) {
            margin: 0.7rem 0 0.1rem;
          }
        }
      }

      .industry-zsys-body3 {
        ::v-deep .dv-scroll-board .rows .ceil {
          font-size: 0.175rem;
        }
      }
    }

    .industry-center {
      .center-zsr {
        top: 0.5rem;
      }

      .center-xzxx {
        width: 90%;
        height: 1.6rem;
        top: initial;
        bottom: 0.2rem;
        left: 5%;

        .center-xzxx-item {
          width: 16.5%;
        }
      }

      .center-zcqk {
        top: 1.2rem;
        width: 4rem;
      }
    }
  }
}
.dialog-img {
  overflow-y: scroll;
  img {
    width: 100%;
    height: 100%;
    margin: 0.1rem 0;
  }
}
</style>
